@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.shipping-default-wrapper {
  margin: 0 15px 15px;
}
